import { Calendar } from '@/components/Calendar';
import { LeadActionButtons } from '@/components/LeadActionButtons';
import type { Lead } from '@/models/entities/lead';
import { LeadStatusGroups } from '@/models/ui/leadStatusGroup.ts';
import { createStepsModel, Steps, type StepsModel } from '@/models/ui/steps';

interface LeadActionsProps {
  readonly selectedLead: Lead;
  readonly errorMessageDelay?: number;
}

export function LeadActions({
  selectedLead,
  errorMessageDelay,
}: LeadActionsProps) {
  const stepsModel = ((): StepsModel | null => {
    if (selectedLead.workflow.statusGroup === LeadStatusGroups.Archive) {
      return null;
    }

    return createStepsModel(selectedLead.workflow.status);
  })();

  const isReadOnly = stepsModel
    ? stepsModel.currentStep.order > Steps.Scheduled.order
    : true;

  return (
    <div>
      <div className="inline-block bg-[#e8e8e8] px-2 py-1 text-xs font-semibold rounded mb-2">
        ACTIONS
      </div>
      <div className="border-b border-gray-300 mb-4"></div>

      <Calendar
        isReadOnly={isReadOnly}
        scheduledDate={selectedLead.workflow.scheduledDate}
      />

      {stepsModel && (
        <LeadActionButtons
          stepsModel={stepsModel}
          hasOdometer={selectedLead.odometer != null}
          errorMessageDelay={errorMessageDelay}
        />
      )}
    </div>
  );
}
